// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.suggest::ng-deep em {
   color: #ffa726;
}

.toolbar {
   align-items: center;
}

.menu>li {
   float: left;
}

.menu>li+li {
   margin-left: 1em;
}

.menu>li>a {
   border: 1px solid #bdc3c7;
   border-radius: 2px;
   cursor: pointer;
   display: block;
   padding: 5px 1em;
   position: relative;
   white-space: nowrap;
}

.menu>li>a:hover {
   background-color: #f7f7f7;
   color: #3d464d;
   text-decoration: none;
}

.toolbar .dropdown.open>a {
   background-color: #ebebeb;
   border-color: #bdc3c7;
}

.menu i {
   font-size: 16px;
}

.menu i+span {
   margin-left: 10px;
}

.menu span+i {
   margin-left: 10px;
}

.menu button {
   min-width: 0;
   padding: 0 12px;
}

.menu button.mat-primary {
   line-height: 30px;
}

.menu button:not(.mat-primary) {
   border: 1px solid #bdc3c7;
   line-height: 28px;
}

.separator {
   border: none;
   border-top: 1px solid #eaeaea;
   height: 0;
   margin: 5px 0;
}

.toolbar .dropdown-menu {
   left: auto;
   right: 0;
}

.chk-all {
   margin-right: 10px;
}

.div-header-chk-all {
   display: flex;
   align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/app/dms/search/search.component.css"],"names":[],"mappings":"AAAA;GACG,cAAc;AACjB;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,yBAAyB;GACzB,kBAAkB;GAClB,eAAe;GACf,cAAc;GACd,gBAAgB;GAChB,kBAAkB;GAClB,mBAAmB;AACtB;;AAEA;GACG,yBAAyB;GACzB,cAAc;GACd,qBAAqB;AACxB;;AAEA;GACG,yBAAyB;GACzB,qBAAqB;AACxB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,YAAY;GACZ,eAAe;AAClB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,yBAAyB;GACzB,iBAAiB;AACpB;;AAEA;GACG,YAAY;GACZ,6BAA6B;GAC7B,SAAS;GACT,aAAa;AAChB;;AAEA;GACG,UAAU;GACV,QAAQ;AACX;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,aAAa;GACb,mBAAmB;AACtB","sourcesContent":[".suggest::ng-deep em {\n   color: #ffa726;\n}\n\n.toolbar {\n   align-items: center;\n}\n\n.menu>li {\n   float: left;\n}\n\n.menu>li+li {\n   margin-left: 1em;\n}\n\n.menu>li>a {\n   border: 1px solid #bdc3c7;\n   border-radius: 2px;\n   cursor: pointer;\n   display: block;\n   padding: 5px 1em;\n   position: relative;\n   white-space: nowrap;\n}\n\n.menu>li>a:hover {\n   background-color: #f7f7f7;\n   color: #3d464d;\n   text-decoration: none;\n}\n\n.toolbar .dropdown.open>a {\n   background-color: #ebebeb;\n   border-color: #bdc3c7;\n}\n\n.menu i {\n   font-size: 16px;\n}\n\n.menu i+span {\n   margin-left: 10px;\n}\n\n.menu span+i {\n   margin-left: 10px;\n}\n\n.menu button {\n   min-width: 0;\n   padding: 0 12px;\n}\n\n.menu button.mat-primary {\n   line-height: 30px;\n}\n\n.menu button:not(.mat-primary) {\n   border: 1px solid #bdc3c7;\n   line-height: 28px;\n}\n\n.separator {\n   border: none;\n   border-top: 1px solid #eaeaea;\n   height: 0;\n   margin: 5px 0;\n}\n\n.toolbar .dropdown-menu {\n   left: auto;\n   right: 0;\n}\n\n.chk-all {\n   margin-right: 10px;\n}\n\n.div-header-chk-all {\n   display: flex;\n   align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
